import axios, { AxiosResponse } from "axios";

const { email, ticket, _csrf } = window.AUTH0_PASSWORD_CHANGE_CONFIG;
export const resetPassword = async (
  newPassword: string,
  confirmNewPassword: string,
): Promise<AxiosResponse> =>
  await axios.post("/lo/reset", {
    newPassword,
    confirmNewPassword,
    email,
    ticket,
    _csrf,
  });
